import React from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { useDisplaySettings } from './DisplaySettingsContext';

const { defaultAlgorithm, darkAlgorithm } = antdTheme;

// High-contrast token overrides. These get merged on top of the algorithm output.
// Values chosen to push contrast above WCAG AAA (7:1) for normal text.
const highContrastLightTokens = {
  colorText: '#000000',
  colorTextSecondary: '#000000',
  colorTextTertiary: '#000000',
  colorBgBase: '#FFFFFF',
  colorBgContainer: '#FFFFFF',
  colorBorder: '#000000',
  colorBorderSecondary: '#000000',
  colorPrimary: '#0000CC',
  colorLink: '#0000CC',
  colorError: '#CC0000',
  colorSuccess: '#006600',
  colorWarning: '#995500',
  lineWidth: 2,
};

const highContrastDarkTokens = {
  colorText: '#FFFFFF',
  colorTextSecondary: '#FFFFFF',
  colorTextTertiary: '#FFFFFF',
  colorBgBase: '#000000',
  colorBgContainer: '#000000',
  colorBorder: '#FFFFFF',
  colorBorderSecondary: '#FFFFFF',
  colorPrimary: '#66CCFF',
  colorLink: '#66CCFF',
  colorError: '#FF6666',
  colorSuccess: '#66FF66',
  colorWarning: '#FFCC66',
  lineWidth: 2,
};

export function ThemedConfigProvider({ children }: { children: React.ReactNode }) {
  const { resolvedTheme, resolvedContrast } = useDisplaySettings();

  const isDark = resolvedTheme === 'dark';
  const isHighContrast = resolvedContrast === 'high';

  const algorithm = isDark ? darkAlgorithm : defaultAlgorithm;

  const contrastTokens = isHighContrast
    ? isDark
      ? highContrastDarkTokens
      : highContrastLightTokens
    : {};

  return (
    <ConfigProvider
      theme={{
        algorithm,
        token: contrastTokens,
      }}
    >
      {children}
    </ConfigProvider>
  );
}
